import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-query",
  "use": "icon-query-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 14\" id=\"icon-query\"><defs><style>#icon-query .cls-1{fill:none;stroke:#1862a0;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}</style></defs><polyline class=\"cls-1\" points=\"1.54 5.75 8.31 12.33 18.41 1.72\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol